export default "__VITE_ASSET__C9hNMIRQ__"